import { ICON_PATHS } from "@/constants/icons";

/** Stroke icon rendered from the shared path registry. */
export function Icon({ name, size = 20, strokeWidth = 1.7, className, style }) {
  const paths = ICON_PATHS[name] ?? ICON_PATHS.overview;
  return (
    <svg
      viewBox="0 0 24 24"
      width={size}
      height={size}
      fill="none"
      stroke="currentColor"
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
      focusable="false"
      className={className}
      style={style}
    >
      {paths.map((d) => (
        <path key={d} d={d} />
      ))}
    </svg>
  );
}

export default Icon;
